module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/extroversion/e098e8e57a245e26a582ddd81294b3bd.png";